// extracted by mini-css-extract-plugin
module.exports = {"text":"GroupTile_text_3JZOe"};